import { setUserOrgPref, setUserPref } from "@eventr/common";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { RegistrationProvider } from "feat/authentication/registrationProvider";

/**
 * Pathless layout route wrapping the pre-auth screens. Provides the shared
 * RegistrationProvider context (consumed by the invite / sign-up pages) and persists
 * `?org=` / `?itin=` from emailed links into the user's prefs. The screens themselves
 * are declared in auth.routes.tsx and rendered through the registry, nested under
 * this route.
 */
export function AuthLayout() {
  const location = useLocation();

  useEffect(() => {
    const url = new URLSearchParams(location.search);
    if (url.get("org")) {
      setUserPref("account", "defaultOrg", url.get("org") || "");
      if (url.get("itin")) {
        setUserOrgPref("itinerary", "defaultItinerary", url.get("itin") || "", url.get("org") || "");
      }
    }
  }, [location.search]);

  return (
    <RegistrationProvider>
      <Outlet />
    </RegistrationProvider>
  );
}
